import * as React from 'react'

import ExcelBtn from './excelBtn'


export default function CommonFiltersActions() {
    return <>
        <ExcelBtn />
    </>
}